export const SET_FILTER_PARAMS = 'SET_FILTER_PARAMS';
export const SET_ALL_FILTER_PARAMS = 'SET_ALL_FILTER_PARAMS';
export const RESET_ALL_FILTER_PARAMS = 'RESET_ALL_FILTER_PARAMS';
export const SET_FILTERS_DATA = 'SET_FILTERS_DATA';

export const BY_MIN_PRICE = 'BY_MIN_PRICE';
export const BY_MAX_PRICE = 'BY_MAX_PRICE';
